
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Attention = props => {
  const modClassName = props.className ? props.className + ' fe_c_icon--attention-solid' : ' fe_c_icon--attention-solid';

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g>
          <g>
            <circle cx="12.5" cy="12.5" r="10.6" className="fe_c_icon__icon fe_c_icon__icon--secondary"></circle>
            <g className="fe_c_icon__icon fe_c_icon__icon--contrast">
              <polygon points="13.2,13.9 13.8,7.4 11.2,7.4 11.8,13.9"></polygon>
              <path d="M11.3,16.6c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2 S11.3,16,11.3,16.6z"></path>
            </g>
          </g>
        </g>
      </g>
    </IconBase>);
};

Attention.defaultProps = {
  title: 'Attention',
};

export default Attention;
